export default __webpack_public_path__ + "static/media/68t.5bbc3930.jpg";